import ApolloClient from 'apollo-client';
import { WebSocketLink } from 'apollo-link-ws';
import { HttpLink } from 'apollo-link-http';
import { split } from 'apollo-link';
import { getMainDefinition } from 'apollo-utilities';
import { InMemoryCache } from 'apollo-cache-inmemory';

export const createApolloClient = () => {
	const adminSecretHeaders = {
		'x-hasura-admin-secret': process.env.REACT_APP_HASURA_SECRET
	};

	const httpLink = new HttpLink({
		uri: `https://${process.env.REACT_APP_GRAPHQL_ENDPOINT}`,
		headers: adminSecretHeaders
	});

	const wsLink = new WebSocketLink({
		uri: `wss://${process.env.REACT_APP_GRAPHQL_ENDPOINT}`,
		options: {
			reconnect: true,
			lazy: true,
			inactivityTimeout: 0,
			connectionParams: {
				headers: adminSecretHeaders
			}
		}
	});

	const link = split(
		({ query }) => {
			const definition = getMainDefinition(query);
			return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
		},
		wsLink,
		httpLink
	);

	const client = new ApolloClient({
		link,
		cache: new InMemoryCache()
	});

	return client;
};
